<template>
  
  <div>  
    <statement-modal
      :is_preview="true"
      :newAnnouncementData="previewData"
      :bit="false"
    />
    <validation-observer
      v-if="newAnnouncementData"
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
    <div class="d-flex justify-content-between">
      <h4 class="mb-0 d-flex align-items-center">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-file-lines" />
        <span class="ml-1">編輯客戶需知</span>
      </h4>
      <b-link href="javascript:void(0)" class="d-flex align-items-center" @click="preview" v-if="ability.can('read', 'settings_announcement')">
        <font-awesome-icon
          style="font-size: 18px"
          icon="fa-solid fa-file-alt"
          class="mr-50"
        />
        預覽
      </b-link>
      </div>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row
              v-for="(announcement, index) in newAnnouncementData.contents"
              :key="`announcement_${index}`"
              class="px-1"
            >
              <b-col
                cols="12"
                class="d-flex backgroundColor3 mb-1 radius-round border-1"
              >
                <b-row class="flex-grow-1 p-2">
                  <!-- product id -->
                      <b-col cols="12">
                          <b-form-group
                            :label="`標題：`"
                            :label-for="`announcement_title${index}`"
                            label-cols-md="2"
                          >
                            <b-form-input
                              v-model="announcement.title"
                              placeholder="輸入標題"
                            />
                          </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-row>
                          <!-- item_description -->
                          <b-col cols="12">
                            <b-form-group
                              label="內容："
                              :label-for="`announcement_content${index}`"
                              label-cols-md="2"
                            >

                            <quill-editor v-model="announcement.content"
                                :options="editorOption" ref="QuillEditor">
                            </quill-editor>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                </b-row>
                <div
                  class="d-flex flex-column justify-content-between py-50 px-25"
                >
                  <feather-icon
                    size="16"
                    icon="PlusIcon"
                    class="cursor-pointer text-success"
                    @click="addItem('contents',index)"
                    v-if="ability.can('create', 'settings_announcement')"
                  />
                  <feather-icon
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer text-danger"
                    @click="removeItem('contents', index, announcement.id)"
                    v-if="ability.can('delete', 'settings_announcement')"
                  />
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              v-if="ability.can('update', 'settings_announcement')"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="reset"
              class="mt-1 mt-sm-0 mobile-w100"
            >
             重置
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea,
  BInputGroup,
  BLink
} from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import statementModal from "@/views/dashboard/modal/modal-statement.vue";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      required,
      previewData: null,
      ability
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormTextarea,
    BInputGroup,
    BLink,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    statementModal
  },
  methods: {
    preview() {
      this.previewData = this.newAnnouncementData.contents;
      this.$bvModal.show("statement-modal-preview");
    },
    addItem(key, index) {
      this.newAnnouncementData[key].splice(index + 1, 0,
        JSON.parse(
          JSON.stringify({
            id: 0,
            title: '',
            content: '',
          })
        )
      );
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newAnnouncementData &&
        this.newAnnouncementData[key] &&
        this.newAnnouncementData[key].length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        this.newAnnouncementData[key].splice(index, 1);
      }
    },
    reset() {
      this.$emit('refetch-data');
    },
    onSubmit() {
      this.newAnnouncementData.value = JSON.stringify(this.newAnnouncementData.contents)
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app/editSettingInfo", this.newAnnouncementData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    announcementData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newAnnouncementData = ref({ id: 1, contents: [{ id: 0 }] });

    watch(
      () => props.announcementData,
      (newVal) => {
        newAnnouncementData.value = { ...newVal };
      }
    );
    const resetAnnouncementData = () => {
      newAnnouncementData.value = JSON.parse(
        JSON.stringify({
          id: 1,
          contents: [{ id: 0 }]
        })
      );
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetAnnouncementData
    );
        const editorOption = {
            modules: {
                toolbar: {
                    container: [
                        ["bold", "italic", "underline", "strike"],
                        // ["blockquote", "code-block"],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ script: "sub" }, { script: "super" }],
                        [{ indent: "-1" }, { indent: "+1" }],
                        [{ direction: "rtl" }],
                        [{ size: ["small", false, "large", "huge"] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        // [
                        //     {
                        //         font: [
                        //             "SimSun",
                        //             "SimHei",
                        //             "Microsoft-YaHei",
                        //             "KaiTi",
                        //             "FangSong",
                        //             "Arial",
                        //         ],
                        //     },
                        // ],
                        [{ align: [] }],
                        ["clean"],
                        ["link"],
                    ],
                },
            },
        };

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      newAnnouncementData,
      editorOption
    };
  },
};
</script>

<style>
.quill-editor {
  background: #fff;
}
</style>


